export const getCompanyId = (): string | null => {
  const value = import.meta.env.VITE_COMPANY_ID?.trim();
  return value ? value : null;
};

export const requireCompanyId = (): string => {
  const companyId = getCompanyId();
  if (!companyId) {
    throw new Error("VITE_COMPANY_ID is required for tenant-aware API requests");
  }
  return companyId;
};